import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import '../purchaseOrder.css';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { checkArray } from '../../../../Components/helper';
import PreviewModal from './PreviewModal';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import Loader from '../../../../Components/Utility/Loader/Loader';
import * as action from '../Store/PurchaseOrder.action';
import EditDocumentDetails from './EditDocumentDetails';
import UploadDocuments from './UploadDocuments';

function PurchaseOrderDocuments({ onOpen, toggle, data, POAddEditAccess, PODeleteAccess }) {
  const { devOrderId } = useParams();
  const dispatch = useDispatch();
  const dateFormat = 'DD-MMM-YYYY, h:mm';
  const { t } = useTranslation('common');
  const {
    purchaseOrderData: { documentList },
    BOMConfigDetails: { productDetails },
    UserDetails: { isSupplierLoggedIn },
  } = useSelector((reduxState) => reduxState);

  const [state, setState] = useState({
    loading: false,
    openPreview: false,
    previewData: null,
    openDeleteModal: false,
    deleteIds: '',
    selectedIdArray: [],
    selectAll: false,
    openEditPopup: false,
    openUploadDocs: false,
    showNameErr: false,
    editPopupData: null,
    supplierData: [],
    userData: [],
  });

  const handlePreview = (element) => {
    setState((prevState) => ({
      ...prevState,
      openPreview: true,
      previewData: element,
    }));
  };

  const togglePreview = () => {
    setState((oldState) => ({
      ...oldState,
      openPreview: false,
      previewData: null,
    }));
  };

  const handleDelete = (element) => {
    setState((eleState) => ({
      ...eleState,
      openDeleteModal: true,
      deleteIds: element._id,
    }));
  };

  const toggleDelete = () => {
    setState((eleStateend) => ({
      ...eleStateend,
      openDeleteModal: false,
      deleteIds: '',
      selectedIdArray: [],
      selectAll: false,
      loading: false,
    }));
  };

  const deletedocs = async () => {
    if (!isEmpty(state.deleteIds)) {
      setState((deleteState) => ({ ...deleteState, loading: true }));
      const params = { devOrderId, ids: state.deleteIds };
      await dispatch(action.deletePODocumentsService(params, data._id, t));
      const res = await dispatch(action.fetchPODocs({ devOrderId }, data?._id));
      if (res) {
        toggleDelete();
      }
    } else {
      setState((prevSatte) => ({ ...prevSatte, loading: true }));
      const params = {
        devOrderId,
        ids: state.selectedIdArray.join(','),
      };
      await dispatch(action.deletePODocumentsService(params, data._id, t));
      const res = await dispatch(action.fetchPODocs({ devOrderId }, data?._id));
      if (res) {
        toggleDelete();
      }
    }
  };

  const onSelectCheckBox = async (e, id) => {
    let selectedItems = [...state.selectedIdArray];
    if (e?.target?.checked) {
      setState((selectState) => ({
        ...selectState,
        selectedIdArray: [...state.selectedIdArray, id],
        selectAll: documentList?.length === [...state.selectedIdArray, id]?.length,
      }));
    } else {
      selectedItems = selectedItems?.filter((item) => item !== id);
      setState((selectState) => ({
        ...selectState,
        selectedIdArray: [...selectedItems],
        selectAll: false,
      }));
    }
  };

  const handleSelectAll = () => {
    if (state.selectAll) {
      setState((newState) => ({
        ...newState,
        selectedIdArray: [],
      }));
    } else {
      const selectedItems = [...state.selectedIdArray];
      for (const item of documentList) {
        const findItems = selectedItems.filter((val) => val === item._id);
        if (findItems.length === 0) {
          selectedItems.push(item._id);
        }
      }
      setState((prevDocState) => ({
        ...prevDocState,
        selectedIdArray: [...selectedItems],
      }));
    }
    setState((originalState) => ({
      ...originalState,
      selectAll: !state.selectAll,
    }));
  };

  const multiDelete = async () => {
    setState((multiDel) => ({
      ...multiDel,
      openDeleteModal: true,
    }));
  };

  const handleEdit = (element) => {
    setState((elementState) => ({
      ...elementState,
      editPopupData: element,
      openEditPopup: true,
    }));
  };

  const toggleEdit = async () => {
    const res = await dispatch(action.fetchPODocs({ devOrderId }, data?._id));
    if (res) {
      setState((editEnd) => ({
        ...editEnd,
        editPopupData: null,
        openEditPopup: false,
        loading: false,
      }));
    }
  };

  const handleSubmit = async (ele) => {
    const params = {
      devOrderId,
      fileName: ele?.docName,
      id: state?.editPopupData?._id,
    };
    const payload = {
      isVisibleToSupplier: ele?.isVisibleToSupplier,
      notes: ele?.notes,
      status: ele?.status?.name,
    };
    if (ele?.docName.trim()) {
      const res = await dispatch(action.putPODocumentsService(params, payload, state?.editPopupData?.poId, t));
      if (res) {
        toggleEdit();
      }
    } else {
      setState((oldState) => ({ ...oldState, showNameErr: true }));
    }
  };

  const uploadDocs = () => {
    setState((oldState) => ({ ...oldState, openUploadDocs: true }));
  };

  const toggleUploadDocs = async () => {
    const res = await dispatch(action.fetchPODocs({ devOrderId }, data?._id));
    if (res) {
      setState((tempState) => ({ ...tempState, openUploadDocs: false }));
    }
  };

  const downLoadDocuments = async (element) => {
    const obj = {
      filename: element.fileName,
      path: element.path,
    };
    await dispatch(action.downloadPODoc(obj));
  };

  const supplierVisibility = (ele, obj) => {
    return isSupplierLoggedIn ? ele?.isVisibleToSupplier && obj : obj;
  };

  useEffect(() => {
    const data = documentList.filter(
      (e) =>
        e?.modifiedBy?.role === 'Supplier' ||
        e?.createdBy?.role === 'Supplier' ||
        e?.modifiedBy?.role === 'SupplierUser' ||
        e?.createdBy?.role === 'SupplierUser',
    );

    const forAdminLogIn = () => {
      return documentList.filter(
        (e) => e?.modifiedBy?.role === 'Admin' || e?.createdBy?.role === 'Admin' || e?.modifiedBy?.role === 'User' || e?.createdBy?.role === 'User',
      );
    };

    const forSupplierLoggedIn = () => {
      return documentList.filter(
        (e) =>
          (e?.modifiedBy?.role === 'Admin' || e?.createdBy?.role === 'Admin' || e?.modifiedBy?.role === 'User' || e?.createdBy?.role === 'User') &&
          e.isVisibleToSupplier === true,
      );
    };

    const userData = isSupplierLoggedIn ? forSupplierLoggedIn() : forAdminLogIn();

    setState((suppData) => ({
      ...suppData,
      supplierData: [...data],
      userData: [...userData],
    }));
  }, [documentList, isSupplierLoggedIn]);

  return (
    <>
      <Modal
        show={onOpen}
        backdrop="static"
        className="custom-modal modal-medium-4x moda-fullpage"
        aria-labelledby="contained-modal-title-vcenter"
        onHide={toggle}
      >
        <Modal.Header>
          <div className="d-flex justify-content-between align-items-center w-100">
            <div className="page-title-filter sticky">
              <div className="title-container">
                <span className="title">
                  {t('FILTER.PURCHASE_DOCUMENT')} | {productDetails?.number}
                </span>
              </div>
              <div className="d-flex">
                {((!isSupplierLoggedIn && POAddEditAccess) || isSupplierLoggedIn) && (
                  <button type="button" title={t('TAKING_DATES.UPLOAD_DOCUMENTS')} className="btn btn-outline" onClick={uploadDocs}>
                    <span className="icon-upload" />
                  </button>
                )}

                {((!isSupplierLoggedIn && PODeleteAccess) || isSupplierLoggedIn) && (
                  <button
                    type="button"
                    title={t('FILTER.DELETE_DOCUMENT')}
                    className="btn btn-outline px-1"
                    disabled={isEmpty(state.selectedIdArray)}
                    onClick={multiDelete}
                  >
                    <span className="icon-delete" />
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          {state.loading && <Loader />}
          {!state.loading && (
            <>
              <div className="modal-buttons mt-5 justify-content-between">
                <div>
                  <span>{t('FILTER.USER_UPLOADED')}</span>
                </div>
                <div className="table-responsive">
                  <table className="table custom-table font-13 mb-5">
                    <thead>
                      <th className="w-80px">
                        <div className="checkbox-label no-label margin-auto">
                          <input
                            type="checkbox"
                            onChange={handleSelectAll}
                            name="check_all"
                            id="check_all"
                            checked={state.selectAll}
                            disabled={isEmpty(documentList)}
                          />
                          <label htmlFor="check_all" className="chklabel">
                            <span />
                          </label>
                        </div>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('FILTER.DOCUMENT_NAME')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('ORDER_PREVIEW_DETAILS.SIGE')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('SPEC_TEMP_LIBRARY.Status')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('FILTER.NOTES')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('FILTER.CREATED_BY_DATE_TIME')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('FILTER.MODIFIED_DATE_TIME')}</span>
                      </th>
                      <th>
                        <span className="cursor-pointer">{t('COSTING_TO_DO_LIST.ACTION')}</span>
                      </th>
                    </thead>
                    <tbody>
                      {checkArray(state.userData) &&
                        state.userData.map((ele, i) => {
                          return (
                            <tr key={i}>
                              <td>
                                {supplierVisibility(
                                  ele,
                                  <div className="checkbox-label no-label margin-auto">
                                    <input
                                      onChange={(e) => onSelectCheckBox(e, ele._id)}
                                      name={`checks_${ele?._id}`}
                                      id={`checks_${ele?._id}`}
                                      type="checkbox"
                                      checked={state.selectedIdArray.filter((val) => val === ele._id).length > 0}
                                    />
                                    <label htmlFor={`checks_${ele?._id}`} className="chklabel" />
                                  </div>,
                                )}
                              </td>
                              <td>{supplierVisibility(ele, ele?.fileName)}</td>
                              <td>{supplierVisibility(ele, ele?.size && `${ele?.size} ${ele?.unit}`)}</td>
                              <td>{supplierVisibility(ele, ele?.status)}</td>
                              <td>{supplierVisibility(ele, ele?.notes)}</td>
                              <td>
                                {supplierVisibility(ele, ele?.createdBy && `${ele?.createdBy?.firstName} ${ele?.createdBy?.lastName}`)}
                                <br />
                                {supplierVisibility(ele, ele?.createdAt && moment(ele?.createdAt).format(dateFormat))}
                              </td>
                              <td>
                                {supplierVisibility(ele, ele?.modifiedBy && `${ele?.modifiedBy?.firstName} ${ele?.modifiedBy?.lastName}`)}
                                <br />
                                {supplierVisibility(ele, ele?.updatedAt && moment(ele?.updatedAt).format(dateFormat))}
                              </td>
                              <td>
                                {supplierVisibility(
                                  ele,
                                  <>
                                    {POAddEditAccess && (
                                      <button
                                        type="button"
                                        className="btn-tbl-action"
                                        title={t('ADD_PO_TEMPLATE_PROVIDER.EDITS')}
                                        onClick={() => handleEdit(ele)}
                                      >
                                        <span className="icon-edit" />
                                      </button>
                                    )}
                                    <button type="button" className="btn-tbl-action" title={t('TAKING_DATES.PREVIEW')} onClick={() => handlePreview(ele)}>
                                      <span className="icon-preview-template" />
                                    </button>
                                    <button type="button" className="btn-tbl-action" title={t('PURCHASE_ORDER_NUMBER.DOWNLOADING')}>
                                      <a
                                        href={() => {
                                          return false;
                                        }}
                                        onClick={() => downLoadDocuments(ele)}
                                        className=" colour-black text-decoration-none"
                                      >
                                        <span className="icon-download" />
                                      </a>
                                    </button>
                                    {PODeleteAccess && (
                                      <button type="button" className="btn-tbl-action" title={t('SPEC_TEMP_LIBRARY.DELETE')} onClick={() => handleDelete(ele)}>
                                        <span className="icon-delete" />
                                      </button>
                                    )}
                                  </>,
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      {isEmpty(state.userData) && (
                        <tr>
                          <td colSpan={8}>
                            <span className="align-items-center justify-content-center d-flex">{t('FILTER.NO_DOCUMENT_FOUND')}</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="modal-buttons mt-5 justify-content-between">
                <div>
                  <span>{t('FILTER.SUPPLIER_UPLOADED')}</span>
                </div>
                <div className="table-responsive">
                  <table className="table custom-table font-13 mb-5">
                    <thead>
                      <tr>
                        <th>
                          <span className="cursor-pointer">{t('FILTER.DOCUMENT_NAME')}</span>
                        </th>
                        <th>
                          <span className="cursor-pointer">{t('ORDER_PREVIEW_DETAILS.SIGE')}</span>
                        </th>
                        <th>
                          <span className="cursor-pointer">{t('SPEC_TEMP_LIBRARY.Status')}</span>
                        </th>
                        <th>
                          <span className="cursor-pointer">{t('FILTER.NOTES')}</span>
                        </th>
                        <th>
                          <span className="cursor-pointer">{t('FILTER.CREATED_BY_DATE_TIME')}</span>
                        </th>
                        <th>
                          <span className="cursor-pointer">{t('FILTER.MODIFIED_DATE_TIME')}</span>
                        </th>
                        <th>
                          <span className="cursor-pointer">{t('COSTING_TO_DO_LIST.ACTION')}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(state.supplierData) &&
                        state.supplierData.map((ele, i) => {
                          return (
                            <tr key={i}>
                              <td>{ele?.fileName}</td>
                              <td>{ele?.size && `${ele?.size} ${ele?.unit}`}</td>
                              <td>{ele?.status}</td>
                              <td>{ele?.notes}</td>
                              <td>
                                {ele?.createdBy && `${ele?.createdBy?.firstName} ${ele?.createdBy?.lastName}`}
                                <br />
                                {ele?.createdAt && moment(ele?.createdAt).format(dateFormat)}
                              </td>
                              <td>
                                {ele?.modifiedBy && `${ele?.modifiedBy?.firstName} ${ele?.modifiedBy?.lastName}`}
                                <br />
                                {ele?.updatedAt && moment(ele?.updatedAt).format(dateFormat)}
                              </td>
                              <td>
                                {isSupplierLoggedIn && (
                                  <button className="btn-tbl-action" type="button" title={t('ADD_PO_TEMPLATE_PROVIDER.EDITS')} onClick={() => handleEdit(ele)}>
                                    <span className="icon-edit" />
                                  </button>
                                )}
                                <button className="btn-tbl-action" type="button" title={t('TAKING_DATES.PREVIEW')} onClick={() => handlePreview(ele)}>
                                  <span className="icon-preview-template" />
                                </button>
                                {isSupplierLoggedIn && (
                                  <button className="btn-tbl-action" type="button" title={t('SPEC_TEMP_LIBRARY.DELETE')} onClick={() => handleDelete(ele)}>
                                    <span className="icon-delete" />
                                  </button>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      {isEmpty(state.supplierData) && (
                        <tr>
                          <td colSpan={7}>
                            <span className="align-items-center justify-content-center d-flex">{t('FILTER.NO_DOCUMENT_FOUND')}</span>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <div>
                <button onClick={toggle} type="button" className="btn btn-default">
                  {t('FILTER.CANCELS')}
                </button>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
      {state.openPreview && <PreviewModal onOpen={state.previewData} toggle={togglePreview} data={state.previewData} />}
      {state.openDeleteModal && (
        <ConfirmationPopup
          onOpen={state.openDeleteModal}
          onConfirm={deletedocs}
          loading={state.loading}
          title={t('TAKING_DATES.DELETES')}
          message={t('FILTER.ARE_U_DELETE_DOCUMENTS')}
          toggle={toggleDelete}
        />
      )}
      {state.openEditPopup && (
        <EditDocumentDetails
          onOpen={state.openEditPopup}
          toggle={toggleEdit}
          data={state.editPopupData}
          handleSubmit={handleSubmit}
          loading={state.loading}
          showErr={state.showNameErr}
        />
      )}
      {state.openUploadDocs && <UploadDocuments setShowGradingGroupError={() => {}} onOpen={state.openUploadDocs} toggle={toggleUploadDocs} showData={data} />}
    </>
  );
}

export default PurchaseOrderDocuments;
